module.exports = __webpack_public_path__ + "img/choose-action-bar-5.934896f2.png";